import { render, staticRenderFns } from "./Tamanho.vue?vue&type=template&id=04406019&"
import script from "./Tamanho.vue?vue&type=script&lang=js&"
export * from "./Tamanho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports